import {
  RemainOnBoardUnitsApi,
  RemainOnBoardUnitUpsertedDto,
  UpsertRestowListCommand,
} from '@planning/app/api'
import { createApiClient } from '@planning/app/http-client'

class RestowService {
  httpClient = createApiClient(RemainOnBoardUnitsApi)

  async upsertRestowList(cmd: UpsertRestowListCommand) {
    const { data } = await this.httpClient.restows(cmd)
    return data
  }

  async delete(ids: number[]) {
    const { data } = await this.httpClient.removeRestow(ids)
    return data
  }

  async getRemainOnBoardByVisitAndContainer(carrierVisitId: number, containerNumber: string) {
    const { data } = await this.httpClient.getRemainOnBoardByVisitAndContainer(
      carrierVisitId,
      containerNumber,
    )
    return data
  }

  async get(
    vesselVisitId?: number,
    containerNumber?: string,
    isNotOnTerminal?: boolean,
  ): Promise<RemainOnBoardUnitUpsertedDto[]> {
    const { data } = await this.httpClient.get(vesselVisitId, containerNumber, isNotOnTerminal)
    return data
  }

  async createRestowFromRob(robId: number) {
    const { data } = await this.httpClient.createRestowFromRemainOnBoard({ remainOnBoardId: robId })
    return data
  }
}

const restowService = new RestowService()

export default restowService
